module.exports = __webpack_public_path__ + "media/images/desktop/app-download-banner-title-904a916b8f1c174c48f96931d8d8b2d6.png";